<div class="m-multi-row" [formGroup]="rowData">
	<div class="form-row row">

<button type="button"
        *ngIf="displayX && canDelete"
        class="close"
        aria-label="Close"
        (click)="removed.emit(index)">
  <span aria-hidden="true">&times;</span>
</button>

		<!-- type -->
		<div class="col-12 col-md-4">
			<div class="text-right m-title app-title-small-light-blue">
				{{'MIXTURE_ROW.TITLE_TYPE' | translate}} {{index + 1}}
			</div>
			<app-dplist-new [valueArr]='teurMaslulArray' formControlName="type" [atrrAriaLabel]="'0'"></app-dplist-new>
			<label class="app-error" *ngIf="rowData.get('type').hasError('required') && displayErrors">{{
				'COMMON.FIELD_REQUIRED' | translate }}</label>
		</div>

		<!-- requesting amount -->
		<div class="col-12 col-md-4 input-wrapper">
			<div class="text-right m-title app-title-small-light-blue">
				{{ 'MIXTURE_ROW.TITLE_AMOUNT' | translate }} {{index + 1}}
			</div>
			<app-animated-input formControlName="amount" [type]="'tel'" attAriaLabel="'0'"
				placeholder="{{'LOAN_DETAILS.Q2.PH1'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="false">
			</app-animated-input>
			<!-- <input currencyMask formControlName="amount" class="app-input" type="tel" placeholder="{{'LOAN_DETAILS.Q2.PH1'|translate}}" [attr.aria-label]="'0'"> -->
			<label class="app-error" *ngIf="rowData.get('amount').hasError('required') && displayErrors">{{
				'COMMON.FIELD_REQUIRED' | translate }}</label>
		</div>

		<!-- period -->
		<div class="col-12 col-md-4 input-wrapper">
			<div class="text-right m-title app-title-small-light-blue">
				{{ 'MIXTURE_ROW.TITLE_PERIOD' | translate }} {{index + 1}}
			</div>

			<app-dplist-new *ngIf="ifSugRibit2Flag" [valueArr]='periodArray' formControlName="period"
				[atrrAriaLabel]="'0'"></app-dplist-new>

			<app-animated-input *ngIf="!ifSugRibit2Flag" formControlName="period" [maxLength]="3" placeholder=""
				attAriaLabel="'0'" [animatedLabel]="false"></app-animated-input>
			<!-- <app-animated-input formControlName="period" attAriaLabel="'0'" placeholder="" [animatedLabel]="false"
				[minValue]="0" [type]="'number'"></app-animated-input> -->

			<!-- <input formControlName="period" class="app-input"  maxlength="3" type="text" placeholder="{{'LOAN_DETAILS.Q2.PH1'|translate}}" [attr.aria-label]="'0'">	 -->
			<label class="app-error" *ngIf="rowData.get('period').hasError('required') && displayErrors">{{
				'COMMON.FIELD_REQUIRED' | translate }}</label>
			<label class="app-error" *ngIf="rowData.get('period').hasError('pattern') && displayErrors">{{
				'COMMON.FIELD_REQUIRED' | translate }}</label>
			<label class="app-error" *ngIf="rowData.get('period').hasError('zero') && displayErrors">{{
				'COMMON.FIELD_REQUIRED' | translate }}</label>
			<label class="app-error"
				*ngIf="rowData.get('period').hasError('min') || rowData.get('period').hasError('max') && displayErrors">{{
				'COMMON.VALID_PEERIOD' | translate }}</label>
			<label class="app-error"
				*ngIf="rowData.get('period').hasError('PeriodNotInArray') && displayErrors">{{
				'MIXTURE_ROW.PERIOD_ERROR_ARRAY' | translate }}</label>
		</div>

		<!-- ribit -->
		<!-- <div class="col-12 col-md-3 input-wrapper">
			<inner-tooltip [qTitle]="titleTooltip(index)" [text]="'MIXTURE_ROW.TOOLTIP_RIBIT'|translate"
				class="m-tooltip app-title-small-blue">
			</inner-tooltip>
			<app-animated-input formControlName="ribit" [type]="'tel'" attAriaLabel="'0'" placeholder=""
				[animatedLabel]="false" [hasPercent]="true"></app-animated-input>
			<label class="app-error" *ngIf="(rowData.get('ribit').hasError('required')) && displayErrors">{{
				'COMMON.FIELD_REQUIRED' | translate }}</label>
			<label class="app-error" *ngIf="((rowData.get('ribit').hasError('min')||rowData.get('ribit').hasError('max') || rowData.get('ribit').hasError('pattern'))
				&& ifValidForSugRibit(3)) && displayErrors">{{
				'COMMON.RIBIT_PRIME_REQUIRED' | translate }}</label>
			<label class="app-error" *ngIf="((rowData.get('ribit').hasError('min')||rowData.get('ribit').hasError('max') || rowData.get('ribit').hasError('pattern'))
				&& ifValidForSugRibit(2)) && displayErrors">{{
				'COMMON.RIBIT_MISHTANA_REQUIRED' | translate }}</label>
			<label class="app-error" *ngIf="((rowData.get('ribit').hasError('min')||rowData.get('ribit').hasError('max') || rowData.get('ribit').hasError('pattern'))
				&& ifValidForSugRibit(1)) && displayErrors">{{
				'COMMON.RIBIT_KVUA_REQUIRED' | translate }}</label>
		</div> -->
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/mixture-row/mixture-row.component.html